import * as Yup from 'yup'

import {isValidBusinessNumber} from '../../../utils/businessNumberValidation'

export const getValidationSchemaForStep = (step, t) => {
  switch (step) {
    case 1:
      return Yup.object().shape({
        businessNumber: Yup.string()
          .test(
            'validBusinessNumber',
            t('points:connectionDrawer.fields.businessNumber.invalid'),
            isValidBusinessNumber,
          )
          .required(
            t('points:connectionDrawer.fields.businessNumber.required'),
          ),
        street: Yup.string().required(
          t('points:connectionDrawer.fields.street.required'),
        ),
        city: Yup.string().required(
          t('points:connectionDrawer.fields.city.required'),
        ),
        stateCode: Yup.string().required(
          t('points:connectionDrawer.fields.stateCode.required'),
        ),
        postalCode: Yup.string().required(
          t('points:connectionDrawer.fields.postalCode.required'),
        ),
      })
    case 2:
      return Yup.object().shape({
        title: Yup.string().required(
          t('points:connectionDrawer.fields.title.required'),
        ),
        firstName: Yup.string().required(
          t('points:connectionDrawer.fields.firstName.required'),
        ),
        lastName: Yup.string().required(
          t('points:connectionDrawer.fields.lastName.required'),
        ),
        email: Yup.string()
          .email(t('points:connectionDrawer.fields.email.invalid'))
          .required(t('points:connectionDrawer.fields.email.required')),
        phoneNumber: Yup.string().required(
          t('points:connectionDrawer.fields.phoneNumber.required'),
        ),
      })
    case 3:
      return Yup.object().shape({})
    default:
      return Yup.object().shape({})
  }
}
